import dayjs from 'dayjs'

/**
 * 15:45 -> 15:45
 * 15:46 -> 16:00
 */
export function getEarlyQuarterTime() {
  const now = dayjs();
  const minute = now.minute();
  const remainder = minute % 15;
  const roundedUp = remainder === 0 ? now : now.add(15 - remainder, "minute");
  return roundedUp.format("HH:mm");
}

/**
 * Checks if the given date string (YYYY-MM-DD) is within the last `days` days from today (using new Date for simplicity)
 * @param dateString
 * @param days
 */
export function isWithinDaysFromNow(dateString: string, days: number) {
  if (!dateString) return false;
  const paid = new Date(dateString);
  if (isNaN(paid.getTime())) return false;

  const today = new Date();

  // Normalize both to local midnight to avoid time-of-day differences
  paid.setHours(0, 0, 0, 0);
  today.setHours(0, 0, 0, 0);

  const msPerDay = 24 * 60 * 60 * 1000;
  const diffDays = Math.floor((today.getTime() - paid.getTime()) / msPerDay);

  // Within last `days` days, not future
  return diffDays >= 0 && diffDays <= days;
}
